import { render, staticRenderFns } from "./InputVials.desktop.vue?vue&type=template&id=36466c2a&scoped=true&"
import script from "./InputVials.desktop.vue?vue&type=script&lang=js&"
export * from "./InputVials.desktop.vue?vue&type=script&lang=js&"
import style0 from "./InputVials.desktop.vue?vue&type=style&index=0&id=36466c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36466c2a",
  null
  
)

export default component.exports